<template>
<!-- orient: hor|ver -->
<div :class="_class">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default: function() {
                return []
            },
        },
    },
    computed: {
        _class: function() {
            let _class = []

            _class.push('kt-grid kt-grid--root')

            this.options.forEach(function(option){
                _class.push('kt-grid--'+option)
            })

            return _class
        }
    }
}
</script>